

export abstract class ReplaceableComponentBase {
    isComponentReplaced: boolean;
    componentDescriptors: any[]; 
    replacementComponentInitialized: boolean;
    instance: any;
    [key: string]: any;
  }
  